import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: `${API_URL}/request-system`,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const requestAdminService = {
  // Templates
  listTemplates: async () => (await api.get('/templates')).data,
  getTemplate: async (id) => (await api.get(`/templates/${id}`)).data,
  createTemplate: async (data) => (await api.post('/templates', data)).data,
  updateTemplate: async (id, data) => (await api.put(`/templates/${id}`, data)).data,
  deleteTemplate: async (id) => (await api.delete(`/templates/${id}`)).data,

  // Categories
  listCategories: async () => (await api.get('/categories')).data,
  getCategory: async (id) => (await api.get(`/categories/${id}`)).data,
  createCategory: async (data) => (await api.post('/categories', data)).data,
  updateCategory: async (id, data) => (await api.put(`/categories/${id}`, data)).data,
  deleteCategory: async (id) => (await api.delete(`/categories/${id}`)).data,

  // Statistics
  getStatistics: async () => (await api.get('/statistics')).data,
};

export default requestAdminService;



